import React, { Component } from 'react';

class Footer extends Component {
  render() {
    return (
      <React.Fragment>
        <span>2019 LOWI 3.4.14</span>
        <span className="ml-auto">Powered by <a>Neuftek 諾客網科</a></span>
      </React.Fragment>
    );
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/footer.js